import { useActiveUserRoles } from "../../util/useActiveUserRoles";
import { BeaconsBeaconTable } from "./BeaconsBeaconTable";

export function Beacons() {
  const { isSolutionOperator } = useActiveUserRoles();

  return (
    <BeaconsBeaconTable currentUserIsSolutionOperator={isSolutionOperator} />
  );
}
